import React from 'react';
import { SlideFrame } from './SlideFrame';
const acts = [{
  act: 'Act I',
  phase: 'Before',
  title: 'Set the scene',
  items: ['Teaser', 'First question', 'Early insight']
}, {
  act: 'Act II',
  phase: 'During',
  title: 'Create the conversation',
  items: ['Aisle breaker', 'Peer-poll', 'Rep-guided Trailer', 'Self-guided experience']
}, {
  act: 'Act III',
  phase: 'After',
  title: 'Turn ideas into action',
  items: ['Insight Snak', 'Follow-up', 'Leads', 'Next conversation']
}];
export function FullPlaySlide() {
  return <SlideFrame topBand eyebrow="The full play" data-id="element-186" data-mp="15u7y5kssl4jz">
      <header className="flex items-end justify-between gap-[5vw]" data-id="element-187" data-mp="15tevow0v917n">
        <h1 className="max-w-[13ch] font-display text-[clamp(48px,6.4vw,106px)] font-bold leading-[0.94] tracking-[-0.03em]" data-id="element-188" data-mp="19wbdikil0taj">
          One continuous conversation.
        </h1>
        <p className="mb-[0.7vh] max-w-[29ch] text-right font-sans text-[clamp(13px,1.05vw,19px)] leading-snug text-black/45" data-id="element-189" data-mp="2laykqu3vkhna">
          One question. One narrative. Multiple touchpoints.
        </p>
      </header>

      <div className="relative mt-[3.2vh] grid min-h-0 flex-1 grid-cols-3 gap-[2vw]" data-id="element-190" data-mp="1kec9enungjnl">
        <div className="pointer-events-none absolute left-[8%] right-[8%] top-[9%] h-[22vh] rounded-[50%] border-t-[clamp(3px,0.3vw,5px)] border-[#D62B22]" aria-hidden="true" data-id="element-191" data-mp="1ffhfoqv59aop" />
        <div className="pointer-events-none absolute bottom-[8%] left-[8%] right-[8%] h-[18vh] rounded-[50%] border-b border-black/20" aria-hidden="true" data-id="element-192" data-mp="1bg8ptx385wyf" />

        {acts.map((act, index) => <section key={act.act} className={`relative z-10 flex flex-col bg-[#F4F1E8] ${index > 0 ? 'border-l border-black/15 pl-[2vw]' : ''}`} data-id="element-193" data-mp="11m9p92isul8l" data-mpi={index}>
            <div className="flex items-center gap-[0.8vw]" data-id="element-194" data-mp="rrritpm00bl3">
              <span className={`flex size-[clamp(34px,3.3vw,60px)] items-center justify-center rounded-full border-[clamp(2px,0.25vw,4px)] border-[#D62B22] bg-[#F4F1E8] font-sans text-[clamp(10px,0.8vw,15px)] font-bold ${index === 1 ? 'bg-[#D62B22] text-white' : 'text-[#D62B22]'}`} data-id="element-195" data-mp="np39zhxab4o4">
                0{index + 1}
              </span>
              <div data-id="element-196" data-mp="d514nnn6eoi3">
                <p className="font-sans text-[clamp(10px,0.8vw,15px)] font-semibold tracking-[0.1em] text-black/35" data-id="element-197" data-mp="d1dbwqpk264f">{act.act}</p>
                <p className="font-sans text-[clamp(11px,0.9vw,17px)] font-semibold text-[#D62B22]" data-id="element-198" data-mp="42jgh3nynlsg">{act.phase}</p>
              </div>
            </div>

            <h2 className="mt-[1.6vh] max-w-[12ch] font-display text-[clamp(23px,2.3vw,41px)] font-semibold leading-[1.02]" data-id="element-199" data-mp="rsvwz2x9uqun">
              {act.title}
            </h2>

            <div className="mt-[2vh] divide-y divide-black/15 border-y border-black/15" data-id="element-200" data-mp="i3ccjstwuoxo">
              {act.items.map(item => <p key={item} className="py-[0.85vh] font-sans text-[clamp(12px,0.95vw,18px)] font-medium text-black/60" data-id="element-201" data-mp="mzt4ky48dng1">
                  {item}
                </p>)}
            </div>
          </section>)}
      </div>

      <div className="relative mt-[2vh] border-t-[clamp(3px,0.3vw,5px)] border-[#D62B22] pt-[1.6vh] text-center" data-id="element-202" data-mp="3083vqyfix6ot">
        <p className="font-display text-[clamp(28px,3.2vw,55px)] font-semibold leading-none" data-id="element-203" data-mp="2va2b492g8zb8">
          The congress is not the campaign. <span className="text-[#D62B22]" data-id="element-204" data-mp="3905r4iaqjws8">It is the middle act.</span>
        </p>
      </div>
    </SlideFrame>;
}